var map = {
	"./bundesliga.png": "15dd",
	"./eredivisie.png": "2831",
	"./la-liga.png": "56d0",
	"./ligue-1.png": "5694",
	"./premier-league.png": "d667",
	"./primeira-liga.png": "cf04",
	"./serie-a.png": "67c6",
	"./superlig.png": "be5d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7367";